import React from 'react';

const TakaokaContext = React.createContext();
 
export default TakaokaContext;